import SheetFiltersItem from "@/common/components/SheetFiltersItem";
import { Option } from "@/common/types/option";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

interface DashboardFilterBadgeProps extends DashboardFilterProps {
  filterKey: DashboardFilters;
  options: Option[];
  instantSearch?: string;
  setSearch?: (value: string) => void;
}

const DashboardFilterSheet = ({
  filterKey,
  options,
  filters,
  setFilters,
  instantSearch,
  setSearch,
}: DashboardFilterBadgeProps) => {
  return (
    <SheetFiltersItem
      label={dashboardFilters[filterKey]}
      value={filters[filterKey]?.value || ''}
      options={[{ label: 'Todas', value: '' }, ...options]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [filterKey]: value }))}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterSheet;
